//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




export default {
  name: "input-search",
  data() {
    return {
      dialogValue: '',
      showDialog: false,
    }
  },
  props:['text'],

  methods: {
    showSearch(){
      this.showDialog=!this.showDialog;
    },
    onConfirmDialog(value) {
      this.dialogValue=value;

      this.$refs.confirmDialog.setInputValue('')
      this.$emit('on-confirm',value)

    },
    delSearch(){
      this.dialogValue=''
      this.$emit('on-clear')
    },


  },



}



// WEBPACK FOOTER //
// ./src/components/search-input.vue